import { parse } from 'query-string';
import { LOCATION_CHANGE } from './../actions';
import { build as constants } from './../helpers';

const initialState = {
  buildHealthInfo: {
    product: constants.PRODUCTS.AXIOM,
    buildNumber: 0,
    buildIds: [0],
    extended: false,
    dispatcherTriggerBy: ['nightly']
  }
};

const buildHealthPage = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search ||
        action.payload.pathname !== '/build-health') {
        return state;
      }
      // These are:
      // n: build number
      // i: build id
      // p: product
      // e: extended
      // The names need to be short because they're part of the URL query.
      const { n, i, p, e } = parse(action.payload.search);
      const parsebuildHealthPageInfo = (
        buildNumber,
        buildIds,
        product,
        extended
      ) => {
        const parsedBuildNumber = parseInt(buildNumber);
        const parsedBuildIds = Array.isArray(buildIds) ?
          buildIds.map(buildId => parseInt(buildId)) : [parseInt(buildIds)];

        return {
          buildNumber: (parsedBuildNumber < 0) || isNaN(parsedBuildNumber) ?
            0 :
            parsedBuildNumber,
          buildIds: parsedBuildIds,
          product: product,
          extended: extended === 'true' ? true : false
        };
      };

      const parsedInfo = parsebuildHealthPageInfo(n, i, p, e);
      return {
        ...state,
        buildHealthInfo: {
          ...state.buildHealthInfo,
          product: parsedInfo.product,
          buildNumber: parsedInfo.buildNumber,
          buildIds: parsedInfo.buildIds,
          extended: parsedInfo.extended
        }
      };
    default: return state;
  }
};

export default buildHealthPage;

const getBuildHealthPage = state => state.buildHealthPage;
export const getBuildHealthInfo = state => getBuildHealthPage(state).buildHealthInfo;
export const getBuildHealthDispatcherTriggerBy = state =>
  getBuildHealthInfo(state).dispatcherTriggerBy || '';
export const getBuildHealthProduct = state => getBuildHealthInfo(state).product || '';
export const getBuildHealthBuildNumber = state =>
  getBuildHealthInfo(state).buildNumber || 0;



// WEBPACK FOOTER //
// src/reducers/buildHealthPage.js